import MuiButton from './MuiButton'
import MuiCard from './MuiCard'
import MuiCardActions from './MuiCardActions'
import MuiCardContent from './MuiCardContent'
import MuiCardHeader from './MuiCardHeader'
import MuiChip from './MuiChip'
import MuiIconButton from './MuiIconButton'
import MuiInputBase from './MuiInputBase'
import MuiLinearProgress from './MuiLinearProgress'
import MuiListItemIcon from './MuiListItemIcon'
import MuiListItemText from './MuiListItemText'
import MuiMenuItem from './MuiMenuItem'
import MuiOutlinedInput from './MuiOutlinedInput'
import MuiPaper from './MuiPaper'
import MuiTable from './MuiTable'
import MuiTableHead from './MuiTableHead'
import MuiTableFooter from './MuiTableFooter'
import MuiTableCell from './MuiTableCell'
import MuiTableRow from './MuiTableRow'
import MuiToggleButton from './MuiToggleButton'
import MuiTypography from './MuiTypography'
import MuiCssBaseline from './MuiCssBaseline'
import MuiMenu from './MuiMenu'

export default (palette, isDarkMode, shadows) => ({
  MuiCssBaseline: MuiCssBaseline(palette, isDarkMode),
  MuiButton: MuiButton(palette, isDarkMode),
  MuiCard: MuiCard(palette, isDarkMode, shadows),
  MuiCardActions,
  MuiCardContent,
  MuiCardHeader,
  MuiChip,
  MuiIconButton: MuiIconButton(palette, isDarkMode),
  MuiInputBase: MuiInputBase(palette, isDarkMode),
  MuiLinearProgress,
  MuiListItemIcon: MuiListItemIcon(palette),
  MuiListItemText: MuiListItemText(palette),
  MuiMenuItem: MuiMenuItem(palette),
  MuiOutlinedInput: MuiOutlinedInput(palette, isDarkMode),
  MuiPaper,
  MuiTable: MuiTable(palette),
  MuiTableHead: MuiTableHead(palette),
  MuiTableFooter: MuiTableFooter(palette),
  MuiTableCell: MuiTableCell(palette),
  MuiTableRow: MuiTableRow(palette),
  MuiToggleButton: MuiToggleButton(palette, isDarkMode),
  MuiTypography,
  MuiMenu: MuiMenu(palette, isDarkMode),
})
